export const LAST_RELOAD_STORAGE_KEY = "battsupport:last-chunk-reload";

export const RELOAD_LOOP_GUARD_MS = 30_000;

// After a deploy, a not-yet-visited route chunk 404s because its hashed file
// no longer exists. One reload gets the tab onto the new build. The
// sessionStorage guard stops a reload loop when reloading doesn't fix it —
// the second failure falls through to the route error boundary.
export function installPreloadErrorReload(): () => void {
	const handlePreloadError = (event: Event) => {
		const lastReloadAt = Number(
			sessionStorage.getItem(LAST_RELOAD_STORAGE_KEY) ?? "0"
		);
		if (Date.now() - lastReloadAt < RELOAD_LOOP_GUARD_MS) {
			return;
		}
		sessionStorage.setItem(LAST_RELOAD_STORAGE_KEY, String(Date.now()));
		event.preventDefault();
		window.location.reload();
	};

	window.addEventListener("vite:preloadError", handlePreloadError);
	return () =>
		window.removeEventListener("vite:preloadError", handlePreloadError);
}
